import React from "react";
import { Grid } from "@material-ui/core";

import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { DateField } from "../../../../../../features/forms/fields/date-field/date-field.component";

import { CbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control.props";
import { END_DATE, START_DATE } from "../../../../../../features/new-execution-briefs/constants";

export const CbTemplateControlStartEndDate = (props: CbTemplateControlProps) => (
  <BorderedBlock>
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <DateField
          form={props.form}
          label={START_DATE.TITLE}
          name={START_DATE.ID}
          required
          userPermissions={props.userPermissions}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <DateField
          form={props.form}
          label={END_DATE.TITLE}
          name={END_DATE.ID}
          required
          userPermissions={props.userPermissions}
        />
      </Grid>
    </Grid>
  </BorderedBlock>
);
